/* ==========================================================================
  main.js
========================================================================== */

var desktop_min_width = 916;

/**
 * Navigation
 */
aucor_navigation(document.getElementById('primary-navigation'), {
  desktop_min_width: desktop_min_width, // min width in pixels
  menu_toggle: '#menu-toggle' // selector for toggle
});

/**
 * Before lazyloaded image is loaded
 */
document.addEventListener('lazybeforeunveil', function(e){

  // current <img> element
  var el = e.target;

  /**
   * Hide possible pre-load image when current image is loaded:
   * <img class="lazyload"> <-- actual image
   * <img class="lazyload-preload"> <-- preload image
   */
  el.addEventListener('load', function() {
    // when loaded, animate blurry version
    var sibling = el.nextSibling;
    if (sibling && sibling !== el && sibling !== null && sibling !== undefined && sibling.nodeType === 1) {
      if (typeof sibling.classList.contains !== "undefined") {
        if (sibling.classList.contains('lazyload-preload')) {
          sibling.classList.add('lazyload-preload--ready');
        }
      } else {
        // legacy browser, skip logic
        sibling.classList.add('lazyload-preload--ready');
      }

    }

  });

});

/**
 * Responsive videos
 */
fitvids();

/**
 * Sticky navigation on scroll, maybe
 */
var scroll_position = 0;
window.addEventListener('scroll', function() {

  var menu = document.getElementById('masthead');
  if (menu) {

    // no changes if mobile menu is open
    if (menu.classList.contains('active') && Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < desktop_min_width) {
      menu.classList.remove('site-header--hidden');
      menu.classList.remove('site-header--sticky');
      return;
    }

    var difference = Math.abs(pageYOffset - scroll_position);
    if (pageYOffset >= 150) {
      if (difference > 8) {
        // show sticky only when scroll upwards and at least 500px from top
        if (pageYOffset >= 150 && pageYOffset <= scroll_position) {
          menu.classList.add('site-header--sticky');
          menu.classList.remove('site-header--hidden');
        } else {
          if (menu.classList.contains('site-header--sticky')) {
            menu.classList.add('site-header--hidden');
            menu.classList.remove('site-header--sticky');
          }
        }
      }
    }
  }

  // quick exit if were are on top
  if (pageYOffset < 150) {
    if (pageYOffset == 0) {
      menu.classList.remove('site-header--hidden');
      menu.classList.remove('site-header--sticky');
    } else if (pageYOffset <= scroll_position) {
      menu.classList.add('site-header--sticky');
    } else {
      menu.classList.remove('site-header--hidden');
      menu.classList.remove('site-header--sticky');
    }
  }


  scroll_position = pageYOffset;
});

/**
 * Search
 */
var search_input = document.querySelector('.js-site-search__input');
var search_toggle = document.querySelector('.js-desktop-search__open');
if (search_toggle) {
  search_toggle.addEventListener('click', function(e) {
    document.body.classList.add('search-active');
    if (search_input) {
      search_input.focus();
    }
  });
}

var search_hide = document.querySelector('.js-site-search__close');
if (search_hide) {
  search_hide.addEventListener('click', function(e) {
    document.body.classList.remove('search-active');
    if (search_input) {
      search_input.value = '';
      search_input.blur();
      search_input.dispatchEvent(new Event('input'));
    }
  });
}

/**
 * Size search UI
 */
var turre_resize_search_bar = function() {
  var cta = document.querySelector('li.cta');
  var form = document.querySelector('.js-site-search');
  if (form && cta) {
    if (desktop_min_width < Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) {
      form.style.maxWidth = 'calc(100% - ' + cta.offsetWidth*2 + 'px)';
      form.style.marginLeft = cta.offsetWidth + 'px';
    } else {
      form.removeAttribute('style');
    }
  }
}
turre_resize_search_bar();
window.addEventListener('resize', function() {
  turre_resize_search_bar();
});

/**
 * Init search
 */
turre_search(
  document.querySelector('.js-site-search__input'),
  document.querySelector('.js-site-search__form'),
  document.querySelector('.js-site-search__results')
);

turre_search(
  document.querySelector('.js-search-form__input'),
  document.querySelector('.js-search-form'),
  document.querySelector('.js-search-form__results')
);

/**
 * Polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function(e){

    // current <img> element
    var el = e.target;

    objectFitPolyfill();
    el.addEventListener('load', function() {
      objectFitPolyfill();
    });

  });

  var media_text = document.querySelectorAll('.wp-block-media-text');
  var media_text_image;
  if (media_text.length) {
    for (var i = media_text.length - 1; i >= 0; i--) {
      media_text_image = media_text[i].querySelector('img');
      if (media_text_image) {
        media_text_image.setAttribute('data-object-fit', 'cover');
        media_text_image.setAttribute('data-object-position', 'top center');
      }
    }
    objectFitPolyfill();
  }

}

/**
 * Blog search focus
 */
var blog_search_form  = document.querySelector('.js-blog-search');
var blog_search_input = document.querySelector('.js-blog-search__input');
var blog_search_activate = document.querySelector('.js-blog-search__activate');
if (blog_search_form && blog_search_input && blog_search_activate) {

  // hide activate button
  var hide_search_activate = function() {
    blog_search_form.classList.add('activate-dismissed');
  }

  // show activate button
  var show_search_activate = function() {
    blog_search_form.classList.remove('activate-dismissed');
  }

  // dismiss activate by clicking
  blog_search_activate.addEventListener('click', function() {
    hide_search_activate();
    blog_search_input.focus();
  });

  // dismiss by typing
  blog_search_input.addEventListener('keyup', function() {
    hide_search_activate();
  });

  blog_search_input.addEventListener('focus', function(e) {
    blog_search_form.classList.add('focus');
    hide_search_activate();
  });
  blog_search_input.addEventListener('blur', function() {
    blog_search_form.classList.remove('focus');
    if (!blog_search_input.value) {
      show_search_activate();
    }
  });
}

/**
 * Fix old content images (add the missing container around them)
 */

// helper function, for wrapping
function wrap(el, wrapper) {
  el.parentNode.insertBefore(wrapper, el);
  wrapper.appendChild(el);
}

// get all figures of the page
var figures = document.querySelectorAll('figure');


// loop thorugh figures, check if they need a wrapper div
for (i = 0; i < figures.length; i++) {

  // check if there is an img tag inside
  var child_nodes = figures[i].childNodes;
  var has_img_inside = false;
  for (x = 0; x < child_nodes.length; x++) {
    if ( child_nodes[x].tagName == 'IMG' ) {
      has_img_inside = true;
    }
  }

  if (
    !figures[i].parentNode.classList.contains('wp-block-image') &&        // check: parent div doesn't have class wp-block-image (correctly working images do)
    !figures[i].classList.contains('wp-block-image') &&                   // check: the figure doesn't have class wp-block-image (correctly working images do)
    !figures[i].parentNode.classList.contains('blocks-gallery-item') &&   // check: that this is not a gallery
    has_img_inside &&                                                     // check: that figure has actually an img inside
    !figures[i].classList.contains('wp-block-media-text__media')          // check: that this is not a textmedia block figure
  ) {
    var wrapper = document.createElement('div');
    wrapper.setAttribute("class", "wp-block-image wp-block-image-js");
    wrap( figures[i] , wrapper);
  }

}
